// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.86.0-next',
  revision: '6c7c02d3b',
  branch: 'next',
  date: 'Fri, 06 Mar 2026 11:42:01 GMT'
};